import styled, { css } from 'styled-components';
import { Typography } from '../../global/theme';
import { mobile_xl } from '../../global/mediaQueryMixin';
import { AlignCenter, FlexBetween, HideScrollbar } from '../../global/commonStyle';

const Container = styled.div`
  position: relative;
  height: 100dvh;
  padding-inline: var(--space-24);
  ${HideScrollbar}

  ${mobile_xl(css`
    padding-inline: var(--space-20);
  `)}
`;

const HeaderLeft = styled.div`
  ${FlexBetween}
  gap: var(--space-24);
`;

const Content = styled.div`
  ${FlexBetween}
  padding-block: var(--space-10);
  background: var(--background-secondary);
  position: sticky;
  z-index: var(--z-index-999);
  top: 0;
  ${mobile_xl(css`
    align-items: center;
    padding-block: var(--space-10) var(--space-10);
    border-bottom: none;
  `)};
`;
const Heading = styled.div`
  ${AlignCenter}
  gap: var(--space-12);
`;

const Title = styled.h1`
  ${Typography.heading_md}
  color: var(--text-primary);
  margin: var(--space-0);
  white-space: nowrap;
  padding: var(--space-3) var(--space-0);
  ${mobile_xl(css`
    padding: var(--space-0);
  `)};
`;

export { HeaderLeft, Content, Heading, Title, Container };
